import NonInclus from '@amo/core/assets/images/icons/non_inclus.svg';
import { useOnClickOutside } from '@amo/core/utils/hooks.js';
import { useCallback, useEffect, useRef, useState } from 'react';
import ChoixRappel from './ChoixRappel/ChoixRappel';
import Coordonnees from './Coordonnees/Coordonnees';
import Creneaux from './Creneaux/Creneaux';

const Booking = (props) => {
    const { setShowBooking } = props;
    const [stepForm, setStepForm] = useState(1);
    const ref = useRef();
    const closeButtonRef = useRef();
    const dialogRef = useRef();
    useOnClickOutside(ref, () => setShowBooking(false));

    useEffect(() => {
        closeButtonRef.current?.focus();
    }, [stepForm]);

    // Bloque le scroll de la page : seul le contenu de la popin défile
    useEffect(() => {
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, []);

    // Focus trap RGAA 7.3 / 12.8
    useEffect(() => {
        const modal = dialogRef.current;
        if (!modal) return;

        const previouslyFocused = document.activeElement;
        const focusableSelector = [
            'button:not([disabled])',
            '[href]:not([disabled])',
            'input:not([disabled]):not([type="hidden"])',
            'select:not([disabled])',
            'textarea:not([disabled])',
            '[tabindex]:not([tabindex="-1"]):not([disabled])',
        ].join(', ');

        const handleKeyDown = (e) => {
            if (e.key !== 'Tab') return;
            const focusableElements = Array.from(modal.querySelectorAll(focusableSelector))
                .filter((el) => el.offsetParent !== null || el === document.activeElement);
            if (focusableElements.length === 0) return;
            const first = focusableElements[0];
            const last = focusableElements[focusableElements.length - 1];

            if (!modal.contains(document.activeElement)) {
                e.preventDefault();
                first.focus();
                return;
            }

            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        };

        modal.addEventListener('keydown', handleKeyDown);

        return () => {
            modal.removeEventListener('keydown', handleKeyDown);
            if (previouslyFocused) previouslyFocused.focus();
        };
    }, []);

    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Escape') {
            setShowBooking(false);
        }
    }, [setShowBooking]);

    return (
        <div
            className={'modal-overlay modal-booking position-fixed bottom-0 top-0 start-0 end-0 p-3'}
            style={{ background: 'rgba(0,0,0,.4)', zIndex: 2 }}
            onKeyDown={handleKeyDown}
            ref={dialogRef}
        >
            <div
                className={'bg-white p-lg-4 p-3 rounded shadow text-center position-relative'}
                style={{ width: '65em', maxWidth: '100%', margin: '0 auto', maxHeight: '100%', overflowY: 'auto' }}
                ref={ref}
                role="dialog"
                aria-modal="true"
                aria-label="Demander un rappel"
            >
                <button
                    type="button"
                    ref={closeButtonRef}
                    className={'align-middle position-absolute cursor-pointer bg-transparent border-0 p-0'}
                    style={{ right: 20, top: 20 }}
                    onClick={() => setShowBooking(false)}
                    aria-label="Fermer"
                >
                    <img src={NonInclus} alt="" aria-hidden="true" className={'close-cross-contrast'} loading="lazy" />
                </button>
                {stepForm === 1 && <Coordonnees setStepForm={setStepForm} bookingMode={props.bookingMode} {...props} />}
                {stepForm === 2 && <ChoixRappel setStepForm={setStepForm} {...props} />}
                {stepForm === 3 && <Creneaux setStepForm={setStepForm} {...props} />}
            </div>
        </div>
    );
};

export default Booking;
